import { UserAccountInfo } from './account.models';
import { FreeRequestParams } from './shared.models';

export enum AuditServiceName {
  CORE_MANAGER = 'core-manager',
  INVOICE_MANAGER = 'invoice-manager',
  IDENTITY = 'identity',
  STICKER_MANAGER = 'sticker-manager',
  ANALYTIC_MANAGER = 'analytic-manager',
  PRODUCT_CATALOG = 'product-catalog',
  RECEIPT_MANAGER = 'receipt-manager'
}

export type Audit = {
  id: string;
  requestId: string;
  statusCode: number;
  serviceName: AuditServiceName;
  ipAddress?: string;
  organizationId?: string;
  endpoint: Endpoint;
  account?: UserAccountInfo;
  createdAt: string;
  updatedAt?: string;
};

export type Endpoint = {
  path: string;
  actionMessage?: string;
  actionCode: string;
  method: string;
  description?: string;
};

export type AuditListParams = FreeRequestParams & {
  accountId?: string;
  accountUsername?: string;
  accountName?: string;
  statusCode?: number;
  service?: string;
  endPointPath?: string;
  endPointMethod?: string;
  organizationId?: string;
};

export enum StatusCode {
  ok = 200,
  created = 201,
  noContent = 204,
  badRequest = 400,
  unauthorized = 401,
  forbidden = 403,
  notFound = 404,
  internalServerError = 500,
  serviceUnavailable = 503
}

export enum HttpMethods {
  get = 'GET',
  post = 'POST',
  put = 'PUT',
  patch = 'PATCH',
  delete = 'DELETE'
}
